import { render, staticRenderFns } from "./SendPicture.vue?vue&type=template&id=f1603554&scoped=true"
import script from "./SendPicture.vue?vue&type=script&lang=js"
export * from "./SendPicture.vue?vue&type=script&lang=js"
import style0 from "./SendPicture.vue?vue&type=style&index=0&id=f1603554&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1603554",
  null
  
)

export default component.exports